import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const afterHandoff = () => {
    authService.syncSessionFromStorage();
    if (authService.isAuthenticated()) {
      return true;
    }
    return router.createUrlTree(['/login']);
  };

  if (authService.consumeCrossAppLogout()) {
    return of(afterHandoff());
  }

  return authService.consumeCrossAppHandoff$().pipe(map(() => afterHandoff()));
};

export const publicOnlyGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const afterHandoff = () => {
    authService.syncSessionFromStorage();
    if (!authService.isAuthenticated()) {
      return true;
    }
    return router.createUrlTree(['/app']);
  };

  if (authService.consumeCrossAppLogout()) {
    return of(afterHandoff());
  }

  return authService.consumeCrossAppHandoff$().pipe(map(() => afterHandoff()));
};
